import {
  Backdrop, Button, Card, CardActions, CardContent, CardHeader, Checkbox, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider,
  FormControl, Grid, TableSortLabel, InputAdornment, LinearProgress, Slide, Slider, Snackbar, Table, TableBody, TableCell, TableContainer
  , TableHead, TableRow, TextField, Typography, Select, createMuiTheme, Paper, TableFooter
} from '@material-ui/core';
import { SearchIcon } from '@material-ui/data-grid';
import Tooltip from '@material-ui/core/Tooltip';
import BarcodeGenerator from 'src/components/BarcodeGenerator';
import SendIcon from '@material-ui/icons/Send';
import CropFreeIcon from '@material-ui/icons/CropFree';
import ScannerIcon from '@material-ui/icons/Scanner';
import MuiAlert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import PrintIcon from '@material-ui/icons/Print';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import trLocale from 'date-fns/locale/tr';
import { getUser, sc } from 'src/utils/Common';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import ExcelExport from 'src/components/ExcelExportScrap';
import moment from 'moment';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import BarcodeVoice from 'src/assets/sound/Bip.mp3';
import ErrorVoice from 'src/assets/sound/Error.mp3';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import MemoryIcon from '@material-ui/icons/Memory';
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  cardUstBolum: {
    maxHeight: 800,
    minHeight: 800,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  rootAdresSearch: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(0)
  },
  selectedRow: {
    backgroundColor: '#ecffde',
    // İlgili diğer stiller
  },
  redText: {
    backgroundColor: '#ffdfd4',
  },
  root1: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(1),
    margin: 'auto',
    maxWidth: '80%',
  },
  header: {
    marginBottom: theme.spacing(1),
  },
  field1: {
    marginBottom: theme.spacing(1),
  },
  table: {
    border: 'none',
    width: '100%'
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};
const customStyles = {
  overlay: {
    zIndex: 9999, // İstediğiniz z-indeksi burada ayarlayabilirsiniz
  },
  // Diğer stil ayarları burada tanımlanabilir
};


function Scrap() {
  const classes = useStyles();
  const today = moment(new Date()).format('YYYY-MM-DD');

  const today1 = new Date();
  let lastWednesday = today1;

  while (lastWednesday.getDay() !== 3) {
    lastWednesday.setDate(lastWednesday.getDate() - 1);
  }







  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [Loading, setLoading] = useState(false);
  const SessionUser = getUser();
  const [ScrapData, setScrapData] = useState([]);
  const [ScrapDataMain, setScrapDataMain] = useState([]);
  const [previous, setPrevious] = React.useState({});
  const [selected, setSelected] = React.useState([]);
  const [ScrapSearch, setScrapSearch] = React.useState("");
  const [ScrapSearchBarkod, setScrapSearchBarkod] = React.useState("");
  const [openEskisiYok, setopenEskisiYok] = useState(false);
  const [openIrsaliye, setopenIrsaliye] = useState(false);
  const [IrsaliyeData, setIrsaliyeData] = useState([]);
  const [Print, setPrint] = React.useState(false);
  const [TeknisyenKodu, setTeknisyenKodu] = useState(0);
  const [TeknisyenData, setTeknisyenData] = useState([]);
  const [DURUM, setDURUM] = useState(-1);
  const [DurumData, setDurumData] = useState([]);
  const [RowSelectedFull, setRowSelectedFull] = useState(false);
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(moment(lastWednesday).format('YYYY-MM-DD'));
  const [bitisTarihi, setBitisTarihi] = React.useState(moment(lastWednesday).format('YYYY-MM-DD'));
  const [FisNo, setFisNo] = useState('');
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState("");
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [ImageUrlMuadil, setImageUrlMuadil] = useState(null);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [BarkodDurum, setBarkodDurum] = React.useState('');
  const [BarkodOkutmaDurum, setBarkodOkutmaDurum] = React.useState('');
  const [SuccessSound, setSuccessSound] = React.useState(false);
  const [ErrorSound, setErrorSound] = React.useState(false);
  const [SendDataEskisiYok, setSendDataEskisiYok] = useState([]);
  const [txtSurucu, settxtSurucu] = React.useState('');
  const [txtPlaka, settxtPlaka] = React.useState('');
  const [txtirsaliyeNo, settxtirsaliyeNo] = React.useState('');
  const [txtSrcIrsaliye, settxtSrcIrsaliye] = React.useState('');
  const [SoundObject, setSoundObject] = React.useState(null);
  const [IrsaliyeTmpData, setIrsaliyeTmpData] = useState([]);

  React.useEffect(() => {
    axios
      .get(`/GetTechnician/${SessionUser.ServiceShopId}`)
      .then(response => {
        if (response.data.length > 0) {
          setTeknisyenData(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });

    axios
      .get(`/GetScrapStatus`)
      .then(response => {
        if (response.data.length > 0) {
          setDurumData(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });

  }, []);
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const isSelected = name => selected.indexOf(name) !== -1;
  const handleClick = (event, row, index) => {
    if (row.RowSelected === 0) {
      row.RowSelected = 1;

    } else {
      row.RowSelected = 0;
    }
    let ScrapDataOld = [...ScrapData];
    setScrapData(ScrapDataOld);
    setScrapDataMain(ScrapDataOld);
  };
  function onSorgula() {
    setLoading(true);
    setRowSelectedFull(false);
    setBarkodDurum('');
    setBarkodOkutmaDurum('');
    axios
      .get(
        `/GetScrapData/${SessionUser.ServiceShopId}/${TeknisyenKodu == '' ? 0 : TeknisyenKodu}/${baslangicTarihi}/${bitisTarihi}/${DURUM == '' ? 0 : DURUM}/${FisNo == '' ? 0 : FisNo}`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setScrapData(response.data);
          setScrapDataMain(response.data);
        } else {
          setScrapData([]);
          setScrapDataMain([]);
        }
      })
      .catch(error => {
        setLoading(false);
        setScrapData([]);
        setScrapDataMain([]);
      });
  }
  const setFilter = (Param) => {
    setScrapSearch(Param);
    setScrapData(ScrapDataMain.filter(item => sc(item.FIS_NO, Param)
      || sc(item.DURUM, Param)
      || sc(item.MALZEME_STOK_NO, Param)
      || sc(item.KRITIK, Param)
      || sc(item.MODEL, Param)
      || sc(item.TEKNISYEN, Param)
      || sc(item.ARAC_TAKIP_NO, Param)
      || sc(item.MALZEME, Param)
      || sc(item.BARKOD_OKUTMA_EKRAN_DURUM, Param)
      || sc(item.BARKOD_OKUTMA_DURUM, Param)
      || sc(item.HURDA_DURUM, Param)
      || sc(item.KUL_URETICI_KODU, Param)
      || sc(item.KUL_MODEL_KODU, Param)))

  };



  const search = "";
  const CikisYapDetay = (event, tip) => {
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const SendData = ScrapData.filter(
      d => parseInt(d.RowSelected) === parseInt(1)
    );
    const data = SendData.map(item => ({
      ServiceShopId: SessionUser.ServiceShopId,
      MaterialId: item.MALZEME_KODU,
      UserId: SessionUser.OrganizationUserId,
      ServicePaperNr: item.FIS_NO,
      Count: item.ADET,
      Type: tip,
      Critical: item.KRITIK,

    }));

    axios
      .post('/SetScrap', data, config)
      .then(response => {
        setLoading(false);
        if (tip === 1) {
          if (response.data[0].ErrorCode.toString() === "0") {
            setUyariTip('success');
          } else {
            setUyariTip('error');
          }
          setUyari(true);
          onSorgula();
          setUyariAciklama(response.data[0].ErrorDescription);

        }

      });
  };

  const CikisYap = (event, tip) => {
    if (
      ScrapData.filter(d => parseInt(d.RowSelected) === parseInt(1))
        .length === 0
    ) {
      setUyariTip('error');
      setUyariAciklama('Seçim yapmadınız!... Lütfen önce seçim yapınız!...');
      setUyari(true);
      return;
    }

    if (ScrapData.filter(d => parseInt(d.RowSelected) === parseInt(1)).filter(x => x.BARKOD_OKUTMA_DURUM === "Barkod Basılmadı").length > 0) {
      setUyariTip('error');
      setUyariAciklama('Seçim yaptığınız fakat barkod u basılmayan malzemeler bulunuyor!... Önce barkod basmanız gerekli!...');
      setUyari(true);
      return;
    }

    if (
      ScrapData.filter(d => parseInt(d.RowSelected) === parseInt(1)).filter(x => x.ARAC_TAKIP_NO === '')
        .length > 0
    ) {
      setUyariTip('error');
      setUyariAciklama('Araç Takip Belgesi çıkartılmayan kayıtlar var!... Lütfen kontrol ediniz!...');
      setUyari(true);
      return;
    }


    confirmAlert({
      message: "Merkeze Göndermek İstediğinizden Emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => CikisYapDetay(event, tip)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };



  const handleteknisyenChange = e => {
    setTeknisyenKodu(e.target.value);
  };
  const handleDurumChange = e => {
    setDURUM(e.target.value);
  };
  const handleBarkodDurumChange = e => {
    setBarkodDurum(e.target.value);
    setScrapData(ScrapDataMain.filter(item => sc(item.BARKOD_OKUTMA_DURUM, e.target.value) && sc(item.BARKOD_OKUTMA_EKRAN_DURUM, BarkodOkutmaDurum)))
  };
  const handleBarkodOkutmaDurumChange = e => {
    setBarkodOkutmaDurum(e.target.value);
    setScrapData(ScrapDataMain.filter(item => sc(item.BARKOD_OKUTMA_EKRAN_DURUM, e.target.value) && sc(item.BARKOD_OKUTMA_DURUM, BarkodDurum)))
  };


  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };

  const exportData = (data) => {
    const SendData = data.filter(
      d => parseInt(d.RowSelected) === parseInt(1)
    );
    return SendData;
  }

  const handleClickFull = () => {
    var RowSelectedFullParam = 0;
    if (RowSelectedFull) {
      RowSelectedFullParam = 0;
    } else {
      RowSelectedFullParam = 1;
    }
    let ScrapDataOld = [...ScrapData];
    ScrapDataOld.forEach(e => {
      e.RowSelected = RowSelectedFullParam;
    });
    setScrapData(ScrapDataOld);
    setRowSelectedFull(RowSelectedFullParam);
  }

  const SetPrintParam = (event) => {

    CikisYapDetay(event, 2);


    var content = document.getElementById("dvPrint");
    let pri;
    const iframe = document.createElement('iframe')
    iframe.setAttribute('title', "Borcode")
    iframe.setAttribute('id', "Borcode")
    iframe.setAttribute('style', 'height: 0px; width: 0px; position: fix;')
    document.body.appendChild(iframe);
    pri = iframe.contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();


  }

  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoading(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + " Numaralı Malzeme Detayı");
    axios.get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrlMuadil(fileURL);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const handleCloseEskisiYok = () => {
    setopenEskisiYok(false);
  };




  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, Header } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {Header.map((headCell) => {
            if (headCell.id === "CHECKBOX") {
              return (
                <TableCell padding='none' align="center">
                  <Checkbox
                    onClick={event =>
                      handleClickFull()
                    }
                    color="primary"
                    checked={RowSelectedFull}
                    inputProps={{
                      'aria-labelledby': "ChcFull"
                    }}
                  />

                </TableCell>
              );
            } else {
              return (
                <TableCell
                  key={headCell.id}
                  align={'left'}
                  padding={headCell.disablePadding ? 'none' : 'default'}
                  sortDirection={orderBy === headCell.id ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)}
                  >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                      <span className={classes.visuallyHidden}>
                        {''}
                      </span>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
              );
            }

          })}
        </TableRow>
      </TableHead>
    );
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const headMalzemeZimmetCells = [
    { id: 'CHECKBOX', numeric: true, disablePadding: true, label: 'Seçim' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'FişNo' },
    { id: 'ISLEM_TARIHI', numeric: true, disablePadding: true, label: 'İşlemTarihi' },
    { id: 'KUL_TEK_KODU', numeric: true, disablePadding: true, label: 'Teknisyen' },
    { id: 'DURUM', numeric: true, disablePadding: true, label: 'Durum' },
    { id: 'KUL_MODEL_KODU', numeric: false, disablePadding: true, label: 'Model' },
    { id: '#', numeric: true, disablePadding: true, label: 'Resim' },
    { id: 'MALZEME_STOK_NO', numeric: false, disablePadding: true, label: 'MalzemeStokNo' },
    { id: 'MALZEME', numeric: false, disablePadding: true, label: 'Malzeme' },
    { id: 'HURDA_DURUM', numeric: false, disablePadding: true, label: 'EskisiDurum' },
    { id: 'KRITIK', numeric: false, disablePadding: true, label: 'Kritik' },
    { id: 'ADET', numeric: true, disablePadding: true, label: 'Adet' },
    { id: 'BARKOD_OKUTMA_DURUM', numeric: false, disablePadding: true, label: 'BarkodBasılma' },
    { id: 'BARKOD_OKUTMA_EKRAN_DURUM', numeric: false, disablePadding: true, label: 'BarkodOkutma' },
    { id: 'ARAC_TAKIP_NO', numeric: false, disablePadding: true, label: 'AraçTakip' }
  ];

  const setPrintDetay = (event) => {
    setPrint(true);
    SetPrintParam(event);
    setPrint(false);

  }

  const handleBarcodeEnterPress = (event) => {
    if (event.key === 'Enter' && event.target.value.length > 9) {
      var FisNo = event.target.value.substring(1, 10);
      var MalzemeKodu = event.target.value.substring(10, event.target.value.length);
      var ScrapDataMainSearch = ScrapDataMain;
      var ChangeIndex = ScrapDataMainSearch.findIndex(item => item.FIS_NO.toString() === FisNo.toString()
        && item.MALZEME_KODU.toString() === MalzemeKodu.toString());
      if (ChangeIndex === -1) {
        setErrorSound(true);
        setUyari(true);
        setUyariTip('error');
        setUyariAciklama("Aradığınız Barkod Bulunamadı!...");
        setScrapSearchBarkod('');
        return;
      } else {
        setLoading(true);
        setSuccessSound(true);
        var config = {
          headers: { 'Content-Type': 'application/json' }
        };
        var data = [{
          ServiceShopId: SessionUser.ServiceShopId,
          MaterialId: MalzemeKodu,
          UserId: SessionUser.OrganizationUserId,
          ServicePaperNr: FisNo,
          Count: 0,
          Type: 3,
          Critical: "",
        }];
        axios.post('/SetScrap', data, config)
          .then(response => {
            if (response.data[0].ErrorCode.toString() === "0") {
              ScrapDataMainSearch[ChangeIndex].BARKOD_OKUTMA_EKRAN_DURUM = "Okutuldu";
              setScrapData(ScrapDataMainSearch);
              setScrapDataMain(ScrapDataMainSearch);
            }
            setLoading(false);
            setErrorSound(false);
          })
          .catch(error => {
            setSuccessSound(false);
            setErrorSound(true);
            setLoading(false);
          });
      }
      setScrapSearchBarkod('');
    }
  };

  const SetEskisiYok = (event, tip) => {
    if (
      ScrapData.filter(d => parseInt(d.RowSelected) === parseInt(1))
        .length === 0
    ) {
      setUyariTip('error');
      setUyariAciklama('Seçim yapmadınız!... Lütfen önce seçim yapınız!...');
      setUyari(true);
      return;
    }



    var Data = ScrapData.filter(d => parseInt(d.RowSelected) === parseInt(1)).map(item => ({
      ...item,
      ACIKLAMA: ''
    }));

    setSendDataEskisiYok(Data)

    setopenEskisiYok(true);


  };

  const setDescription = (Aciklama, FisNo, MalzemeKodu) => {
    // ScrapData dizisini döngüye alarak ACIKLAMA alanını güncelleyin
    var Data = SendDataEskisiYok.map(item => {
      if (
        item.FIS_NO === FisNo &&
        item.MALZEME_KODU === MalzemeKodu
      ) {
        // Eşleşen satırın ACIKLAMA alanını istediğiniz değere güncelleyin
        item.ACIKLAMA = Aciklama;
      }
      return item;
    });

    // Güncellenmiş veriyi kullanmak için setSendDataEskisiYok işlevini çağırın
    setSendDataEskisiYok(Data);

  }

  const CikisYapEskisiYok = (event) => {
    if (
      SendDataEskisiYok.filter(d => d.ACIKLAMA === '')
        .length > 0
    ) {
      setUyariTip('error');
      setUyariAciklama('Açıklama girmediniz!... Lütfen önce açıklama giriniz!...');
      setUyari(true);
      return;
    }

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    const data = SendDataEskisiYok.map(item => ({
      ServiceShopId: SessionUser.ServiceShopId,
      MaterialId: item.MALZEME_KODU,
      UserId: SessionUser.OrganizationUserId,
      ServicePaperNr: item.FIS_NO,
      Count: item.ADET,
      Type: 4,
      Critical: item.ACIKLAMA,

    }));

    axios
      .post('/SetScrap', data, config)
      .then(response => {
        setLoading(false);
        if (response.data[0].ErrorCode.toString() === "0") {
          setUyariTip('success');
        } else {
          setUyariTip('error');
        }
        setUyari(true);
        onSorgula();
        setUyariAciklama(response.data[0].ErrorDescription);
        setopenEskisiYok(false);
      });


  };

  const onIrsaliye = () => {

    settxtPlaka("");
    settxtSurucu("");
    setIrsaliyeTmpData([]);
    var Data = ScrapData.filter(d => parseInt(d.RowSelected) === parseInt(1));
    setIrsaliyeData(Data)
    setopenIrsaliye(true);
  }

  const SetIrsaliyeTmpDataCreate = () => {



    if (IrsaliyeData.filter(x => x.BARKOD_OKUTMA_DURUM === "Basılmadı").length > 0) {
      setUyariTip('error');
      setUyariAciklama('Barkod basılmayan kayıtlar var bu kayıtları listeden çıkatınız!...');
      setUyari(true);
      return;
    }

    if (IrsaliyeData.filter(x => x.BARKOD_OKUTMA_EKRAN_DURUM === "Okutulmadı").length > 0) {
      setUyariTip('error');
      setUyariAciklama('Barkod okutulmayan kayıtlar var bu kayıtları listeden çıkatınız!...');
      setUyari(true);
      return;
    }

    if (txtPlaka === '') {
      setUyariTip('error');
      setUyariAciklama('Lütfen önce plaka giriniz!...');
      setUyari(true);
      return;
    }

    if (txtSurucu === '') {
      setUyariTip('error');
      setUyariAciklama('Lütfen önce sürücü giriniz!...');
      setUyari(true);
      return;
    }
    var time = new Date();
    var day = time.getDate().toString().padStart(2, '0');
    var month = (time.getMonth() + 1).toString().padStart(2, '0'); // Ay, 0-11 arasında olduğu için +1 ekliyoruz.
    var year = time.getFullYear();
    var hours = time.getHours().toString().padStart(2, '0');
    var minutes = time.getMinutes().toString().padStart(2, '0');
    var seconds = time.getSeconds().toString().padStart(2, '0');
    var Irsaliye = SessionUser.ServiceShopCode.toString() + day.toString() + month.toString() + year.toString() + hours.toString() + minutes.toString() + seconds.toString();



    var AnaVeri = [{
      "irsaliyeNo": Irsaliye
      , "tarih": day.toString() + "." + month.toString() + "." + year.toString() + " " + hours.toString() + ":" + minutes.toString()
      , "teslimAlan": txtSurucu
      , "plaka": txtPlaka
      , "kalemler": IrsaliyeData
    }]
    setIrsaliyeTmpData(AnaVeri);
  }

  const setYazdir = (event) => {
    var content = document.getElementById("dvIrsaliye");
    let pri;
    const iframe = document.createElement('iframe')
    iframe.setAttribute('title', "Araç Takip")
    iframe.setAttribute('id', "Araç Takip")
    iframe.setAttribute('style', 'height: 0px; width: 0px; position: fix;')
    document.body.appendChild(iframe);
    pri = iframe.contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }


  const GetIrsaliye = () => {
    if (txtSrcIrsaliye === '') {
      setUyariTip('error');
      setUyariAciklama('Araç Takip Numarası Giriniz!...');
      setUyari(true);
      return;
    }
    axios
      .get(
        `/GetScrapData/${SessionUser.ServiceShopId}/${0}/${txtSrcIrsaliye}/${txtSrcIrsaliye}/${1000}/${0}`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setIrsaliyeTmpData(response.data);
        } else {
          setIrsaliyeTmpData([]);
        }
      })
      .catch(error => {
        setLoading(false);
        setIrsaliyeTmpData([]);
      });
  }

  const SetIrsaliye = () => {

    if (IrsaliyeData.length === 0) {
      setUyariAciklama("Gönderilecek data oluşturulmadı önce oluşturma işlemini yapınız!...");
      setUyariTip('error');
      setUyari(true);
      return;
    }


    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const SendData = IrsaliyeTmpData[0].kalemler;



    const data = SendData.map(item => ({
      ServiceShopId: SessionUser.ServiceShopId,
      MaterialId: item.MALZEME_KODU,
      UserId: SessionUser.OrganizationUserId,
      ServicePaperNr: item.FIS_NO,
      Count: item.ADET,
      Type: 1000,
      Critical: item.KRITIK + "|" + IrsaliyeTmpData[0].irsaliyeNo + "|" + IrsaliyeTmpData[0].teslimAlan + "|" + IrsaliyeTmpData[0].plaka + "|" + IrsaliyeTmpData[0].tarih,

    }));

    axios
      .post('/SetScrap', data, config)
      .then(response => {
        setLoading(false);
        if (response.data[0].ErrorCode.toString() === "0") {
          setUyariTip('success');
        } else {
          setUyariTip('error');
        }
        setUyari(true);
        setUyariAciklama(response.data[0].ErrorDescription);
        setopenIrsaliye(false);
      });


    data.forEach(item => {
      var index = ScrapData.findIndex(x => x.MALZEME_KODU == item.MaterialId && x.FIS_NO == item.ServicePaperNr);
      if (index !== -1) {
        ScrapData[index].ARAC_TAKIP_NO = IrsaliyeTmpData[0].irsaliyeNo;
        ScrapDataMain[index].ARAC_TAKIP_NO = IrsaliyeTmpData[0].irsaliyeNo;
      }
    });

  }
  useEffect(() => {
    if (SuccessSound) {
      const sound = new Audio(BarcodeVoice); // Ses dosyasının yolunu buraya ekleyin
      setSoundObject(sound);
      sound.play();

      sound.onended = () => {
        setSuccessSound(false);
        setSoundObject(null);
      };
    }
  }, [SuccessSound]);

  useEffect(() => {
    if (ErrorSound) {
      const sound = new Audio(ErrorVoice); // Ses dosyasının yolunu buraya ekleyin
      setSoundObject(sound);
      sound.play();

      sound.onended = () => {
        setErrorSound(false);
        setSoundObject(null);
      };
    }
  }, [ErrorSound]);


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      {SuccessSound && SoundObject && ''}
      {ErrorSound && SoundObject && ''}
      <Container maxWidth="xl">
        <Card>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardHeader
                    avatar={
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant="contained"
                            fullWidth
                            className={classes.button}
                            color="secondary"
                            endIcon={<SearchIcon></SearchIcon>}
                            onClick={onSorgula}
                          >
                            Sorgula
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant="contained"
                            className={classes.button}
                            style={{ backgroundColor: 'blue', color: 'white' }}
                            fullWidth
                            endIcon={<PrintIcon></PrintIcon>}
                            onClick={(event) => setPrintDetay(event)}
                          >
                            BarkodBas
                          </Button>
                        </Grid>

                      </Grid>
                    }
                    action={
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={3}>
                          <ExcelExport JsonData={exportData(ScrapData)} />
                        </Grid>
                        <Grid item xs={12} sm={3} alignItems='center' alignContent='center'>
                          <Button
                            variant="contained"
                            fullWidth
                            align="center"
                            style={{ backgroundColor: 'red', color: 'white' }}
                            endIcon={<LinkOffIcon></LinkOffIcon>}
                            onClick={event => SetEskisiYok(event, 1)}
                          >
                            EskİYok
                          </Button>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                          <Button
                            variant="contained"
                            fullWidth
                            className={classes.button}
                            color="secondary"
                            endIcon={<AirportShuttleIcon></AirportShuttleIcon>}
                            onClick={onIrsaliye}
                          >
                            AraçTeslİm
                          </Button>

                        </Grid>
                        <Grid item xs={12} sm={3} alignItems='center' alignContent='center'>
                          <Button
                            variant="contained"
                            fullWidth
                            align="center"
                            style={{ backgroundColor: 'green', color: 'white' }}
                            endIcon={<SendIcon></SendIcon>}
                            onClick={event => CikisYap(event, 1)}
                          >
                            Gönder
                          </Button>
                        </Grid>
                      </Grid>
                    }
                  />
                  <Divider />
                  <CardActions>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={2}>
                        <FormControl variant="outlined" className={classes.fields}>
                          <Typography variant="h6" component="h2">
                            <Select
                              native
                              value={DURUM}
                              onChange={handleDurumChange}
                              fullWidth
                              labelId="durum_label"
                              inputProps={{
                                name: 'durum_select',
                                id: 'durum_select'
                              }}
                            >
                              <option value="" defaultValue>
                                {DURUM}
                              </option>
                              {DurumData.map(p => {
                                return (
                                  <option
                                    key={p.DURUM}
                                    value={p.DURUM}
                                  >
                                    {p.ACIKLAMA}
                                  </option>
                                );
                              })}
                            </Select>
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <FormControl variant="outlined" className={classes.fields}>
                          <Typography variant="h6" component="h2">
                            <Select
                              native
                              value={TeknisyenKodu}
                              onChange={handleteknisyenChange}
                              fullWidth
                              labelId="teknisyen_label"
                              inputProps={{
                                name: 'teknisyen_select',
                                id: 'teknisyen_select'
                              }}
                            >
                              <option value="" defaultValue>
                                {TeknisyenKodu}
                              </option>
                              {TeknisyenData.map(p => {
                                return (
                                  <option
                                    key={p.TEKNISYEN_KODU}
                                    value={p.TEKNISYEN_KODU}
                                  >
                                    {p.KUL_TEK_KODU + '-' + p.ACIKLAMA}
                                  </option>
                                );
                              })}
                            </Select>
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <FormControl variant="outlined" className={classes.fields}>
                          <Typography variant="h6" component="h2">
                            <ThemeProvider theme={materialTheme}>
                              <MuiPickersUtilsProvider
                                utils={DateFnsUtils}
                                locale={localeMap['tr']}
                              >
                                <KeyboardDatePicker
                                  color="primary"
                                  fullWidth
                                  inputVariant="outlined"
                                  invalidDateMessage={'Hatalı Tarih Formatı'}
                                  format={'dd.MM.yyyy'}
                                  variant="outlined"
                                  value={baslangicTarihi}
                                  onChange={e => handleDateChange(e, 1)}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            </ThemeProvider>
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <FormControl variant="outlined" className={classes.fields}>
                          <Typography variant="h6" component="h2">
                            <ThemeProvider theme={materialTheme}>
                              <MuiPickersUtilsProvider
                                utils={DateFnsUtils}
                                locale={localeMap['tr']}>
                                <KeyboardDatePicker
                                  color="primary"
                                  fullWidth
                                  inputVariant="outlined"
                                  invalidDateMessage={'Hatalı Tarih Formatı'}
                                  format={'dd.MM.yyyy'}
                                  variant="outlined"
                                  value={bitisTarihi}
                                  onChange={e => handleDateChange(e, 2)}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            </ThemeProvider>
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <FormControl variant="outlined" className={classes.fields}>
                          <Typography variant="h6" component="h2">
                            <TextField
                              fullWidth
                              type="number"
                              required
                              placeholder='Fiş Numarası'
                              value={FisNo}
                              onInput={(e) => {
                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 9)
                              }}
                              onChange={(e) => setFisNo(e.target.value)}
                              variant="outlined" />
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={1}>
                        <FormControl variant="outlined" className={classes.fields}>
                          <Typography variant="h6" component="h2">
                            <Select
                              native
                              value={BarkodDurum}
                              onChange={handleBarkodDurumChange}
                              fullWidth
                              labelId="durum_label"
                              inputProps={{
                                name: 'durum_select',
                                id: 'durum_select'
                              }}
                            >
                              <option value="" defaultValue>
                                {'Barkod Basım'}
                              </option>
                              <option value="Basılmadı" defaultValue>
                                {'Basılmadı'}
                              </option>
                              <option value="Basıldı" defaultValue>
                                {'Basıldı'}
                              </option>

                            </Select>
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={1}>
                        <FormControl variant="outlined" className={classes.fields}>
                          <Typography variant="h6" component="h2">
                            <Select
                              native
                              value={BarkodOkutmaDurum}
                              onChange={handleBarkodOkutmaDurumChange}
                              fullWidth
                              labelId="durum_label"
                              inputProps={{
                                name: 'durum_select',
                                id: 'durum_select'
                              }}
                            >
                              <option value="" defaultValue>
                                {'Barkod Okutma'}
                              </option>
                              <option value="Okutulmadı" defaultValue>
                                {'Okutulmadı'}
                              </option>
                              <option value="Okutuldu" defaultValue>
                                {'Okutuldu'}
                              </option>

                            </Select>
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                          <TextField
                            label="Arama Yapınız..."
                            value={ScrapSearch}
                            name={ScrapSearch}
                            className={clsx(classes.margin, classes.textField)}
                            onChange={event => { setFilter(event.target.value) }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <SearchIcon />
                                </InputAdornment>
                              )
                            }}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                          <TextField
                            label="Barkod Okutma İşlemleri"
                            value={ScrapSearchBarkod}
                            name={ScrapSearchBarkod}
                            className={clsx(classes.margin, classes.textField)}
                            onChange={event => { setScrapSearchBarkod(event.target.value) }}
                            onKeyPress={handleBarcodeEnterPress}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <CropFreeIcon />
                                </InputAdornment>

                              ),
                              startAdornment: (
                                <InputAdornment position="start">
                                  <ScannerIcon />
                                </InputAdornment>
                              )
                            }}
                          />

                        </FormControl>
                      </Grid>

                    </Grid>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <TableContainer className={classes.container}>
              <Table size="small" stickyHeader>
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  Header={headMalzemeZimmetCells}
                />
                <TableBody>
                  {stableSort(ScrapData, getComparator(order, orderBy))
                    .map((row, index) => {
                      const isItemSelected = isSelected(index);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (

                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={index}
                          selected={isItemSelected}
                          className={row.RowSelected ? classes.selectedRow : ''}
                        >
                          <TableCell
                            align="left"
                            padding="checkbox">
                            <Checkbox
                              onClick={event =>
                                handleClick(event, row, index)
                              }
                              checked={row.RowSelected}
                              color="primary"
                              inputProps={{
                                'aria-labelledby': labelId
                              }}
                            />
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.SONUC_NOTU}
                          >
                            {
                              row.ESLENEN_FIS_NO === 0 ? <b style={{ color: 'blue' }}>{row.FIS_NO}</b> : <b style={{ color: 'red' }}>{row.FIS_NO}</b>
                            }
                            

                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.ISLEM_TARIHI}
                          >
                            {row.ISLEM_TARIHI}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.TEKNISYEN}
                          >
                            {row.TEKNISYEN.substring(0,10)}...
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.DURUM}
                          >
                            {row.DURUM.substring(0,10)}...
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'

                          >
                            {row.KUL_MODEL_KODU}
                          </TableCell>

                          <TableCell
                            align="center"
                            padding='none'

                          >
                            <ImageSearchIcon
                              onClick={(event) => GetMaterialImage(event, row.MALZEME_STOK_NO.replace(/^0+/, ''))}
                              color="primary"
                            />
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'

                          >
                            {row.MALZEME_STOK_NO}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.MALZEME}
                          >
                            {row.MALZEME.substring(0,20)}...
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'

                          >
                            {row.HURDA_DURUM}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'

                          >
                            {row.KRITIK}
                          </TableCell>
                          <TableCell
                            align="center"
                            padding='none'

                          >
                            {row.ADET}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            className={`${classes.tableCell} ${row.BARKOD_OKUTMA_DURUM === 'Basılmadı' ? classes.redText : ''}`}
                          >
                            {row.BARKOD_OKUTMA_DURUM}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            className={`${classes.tableCell} ${row.BARKOD_OKUTMA_EKRAN_DURUM === 'Okutulmadı' ? classes.redText : ''}`}
                          >
                            {row.BARKOD_OKUTMA_EKRAN_DURUM}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                          >
                            {row.ARAC_TAKIP_NO}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={Print}
        onClose={() => setPrint(false)}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          Etiket Bas
        </DialogTitle>
        <Divider />
        <DialogContent>
          <div id="dvPrint">
            {ScrapData?.filter(d => parseInt(d.RowSelected) === parseInt(1)).map((item) => {
              return (
                <BarcodeGenerator
                  KUL_URETICI_KODU={item.KUL_URETICI_KODU}
                  KUL_BIRIM_KODU={item.KUL_BIRIM_KODU}
                  FIS_NO={item.FIS_NO}
                  KRITIK={item.KRITIK}
                  ADET={item.ADET}
                  MALZEME_STOK_NO={item.MALZEME_STOK_NO}
                  MALZEME={item.MALZEME}
                  UYIL={item.UYIL}
                  UDONEM={item.UDONEM}
                  KUL_MODEL_KODU={item.KUL_MODEL_KODU}
                  MODEL={item.MODEL}
                  MALZEME_KODU={item.MALZEME_KODU}
                />
              );
            })}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => SetPrintParam(event)}
            className={classes.button}
            endIcon={<PrintIcon>Close</PrintIcon>}
          >
            Yazdır
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth='lg'
        onClose={handleCloseMaterialFile}      >
        <DialogTitle>
          {openMaterialFileTitle}
        </DialogTitle>
        <DialogContent>
          {Loading ? <LinearProgress
            status="loading"
          /> : <img style={{ width: '100%' }} alt='' src={ImageUrlMuadil} />}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openEskisiYok}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth='lg'
        onClose={handleCloseMaterialFile}      >
        <DialogTitle>
          Eskisi Yok Gerekçeleri
        </DialogTitle>
        <Divider />
        <DialogContent>
          <TableContainer className={classes.container}>
            <Table className={classes.table} size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">FişNo</TableCell>
                  <TableCell align="left">Teknisyen</TableCell>
                  <TableCell align="left">MalzemeKodu</TableCell>
                  <TableCell align="left">Malzeme</TableCell>
                  <TableCell align="left">Kritik</TableCell>
                  <TableCell align="left">Adet</TableCell>
                  <TableCell align="left">Acıklama</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {SendDataEskisiYok
                  .map((row, index) => {
                    const isItemSelected = isSelected(index);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={index}
                        selected={isItemSelected}
                      >

                        <TableCell align="left">
                          {row.FIS_NO}
                        </TableCell>
                  
                        <TableCell align="left">
                          {row.TEKNISYEN}
                        </TableCell>
                        <TableCell
                          align="left"
                          title={row.MALZEME_STOK_NO}

                        >
                          {row.MALZEME_STOK_NO}
                        </TableCell>
                        <TableCell
                          align="left"
                          title={row.MALZEME}

                        >
                          {row.MALZEME}
                        </TableCell>
                        <TableCell
                          align="right"
                          title={row.KRITIK}

                        >
                          {row.KRITIK}
                        </TableCell>
                        <TableCell align="left">
                          {row.ADET}
                        </TableCell>
                        <TableCell
                          align="left"

                        >
                          <TextField
                            id="standard-multiline-static"
                            multiline
                            variant="outlined"
                            fullWidth
                            onChange={event => { setDescription(event.target.value, row.FIS_NO, row.MALZEME_KODU) }}
                            value={row.ACIKLAMA}
                            rows={4}
                          />
                        </TableCell>

                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={CikisYapEskisiYok} color="primary">
            Gönder
          </Button>
          <Button onClick={handleCloseEskisiYok} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openIrsaliye}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth='lg'
        onClose={e => setopenIrsaliye(false)}>
        <DialogTitle>
          Araç Teslim
        </DialogTitle>
        <Divider />
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                type="text"
                required
                size='small'
                placeholder='Sürücü'
                value={txtSurucu}
                onChange={(e) => settxtSurucu(e.target.value)}
                variant="outlined" />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                type="text"
                required
                size='small'
                placeholder='Plaka'
                value={txtPlaka}
                onChange={(e) => settxtPlaka(e.target.value)}
                variant="outlined" />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                variant="contained"
                fullWidth
                align="center"
                style={{ backgroundColor: 'blue', color: 'white' }}
                endIcon={<MemoryIcon></MemoryIcon>}
                onClick={event => SetIrsaliyeTmpDataCreate()}
              >
                Oluştur
              </Button>
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                variant="contained"
                fullWidth
                align="center"
                style={{ backgroundColor: 'green', color: 'white' }}
                endIcon={<SendIcon></SendIcon>}
                onClick={event => SetIrsaliye()}
              >
                Kaydet
              </Button>
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                variant="contained"
                fullWidth
                align="center"
                color='secondary'
                endIcon={<PrintIcon></PrintIcon>}
                onClick={event => setYazdir(event)}
              >
                Yazdır
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
        <Divider />
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={10}>
              <TextField
                fullWidth
                type="text"
                required
                size='small'
                placeholder='Araç Takip Numarası Giriniz!...'
                value={txtSrcIrsaliye}
                onChange={(e) => settxtSrcIrsaliye(e.target.value)}
                variant="outlined" />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                variant="contained"
                fullWidth
                color="secondary"
                align="center"
                endIcon={<SearchIcon></SearchIcon>}
                onClick={event => GetIrsaliye()}
              >
                Sorgula
              </Button>
            </Grid>

          </Grid>
        </DialogActions>
        <Divider />
        <DialogContent>
          <div id="dvIrsaliye" name="dvIrsaliye">
            <Paper variant="outlined">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} style={{ textAlign: 'center' }}>
                  <Typography variant="h4">
                    {SessionUser?.ServiceShopCode + " " + SessionUser?.ServiceShopName}  Malzeme Eskisi Araç Teslim
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TableContainer component={Paper}>
                    <Table size="small" style={{ minWidth: '210mm' }} stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left" colSpan={3} style={{ textAlign: 'left' }}>
                            <b>Takip No : </b>{IrsaliyeTmpData[0]?.irsaliyeNo}
                          </TableCell>
                          <TableCell align="right" colSpan={3} style={{ textAlign: 'right' }}>
                            <b>Tarih : </b>{IrsaliyeTmpData[0]?.tarih}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="left" colSpan={3} style={{ textAlign: 'left' }}>
                            <b>Araç Plakası : </b>{IrsaliyeTmpData[0]?.plaka}
                          </TableCell>
                          <TableCell align="right" colSpan={3} style={{ textAlign: 'right' }}>
                            <b>Sürücü : </b>{IrsaliyeTmpData[0]?.teslimAlan}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="left" colSpan={6}>
                            <br />
                            <br />
                            <br />
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left" style={{ textAlign: 'left' }}>Sıra</TableCell>
                          <TableCell align="left" style={{ textAlign: 'left' }}>FişNo</TableCell>
                          <TableCell align="left" style={{ textAlign: 'left' }}>MalzemeKodu</TableCell>
                          <TableCell align="center" style={{ textAlign: 'center' }}>Malzeme</TableCell>
                          <TableCell align="left" style={{ textAlign: 'left' }}>Kritik</TableCell>
                          <TableCell align="right" style={{ textAlign: 'right' }}>Adet</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {IrsaliyeTmpData[0]?.kalemler.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell align="left" style={{ textAlign: 'left' }}>
                              {`${index + 1})`}
                            </TableCell>
                            <TableCell align="left" style={{ textAlign: 'left' }}>
                              {row.FIS_NO}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{ textAlign: 'left' }}
                              title={row.MALZEME_STOK_NO}>
                              {row.MALZEME_STOK_NO}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ textAlign: 'center' }}
                              title={row.MALZEME}>
                              {row.MALZEME}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{ textAlign: 'left' }}
                              title={row.KRITIK}>
                              {row.KRITIK}
                            </TableCell>
                            <TableCell align="right" style={{ textAlign: 'right' }}>
                              {row.ADET}
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow>
                          <TableCell align="left" colSpan={3}>
                            <br />
                            <br />
                            <b>Teslim Eden İmza</b>
                            <br />
                            <br />
                            <br />
                            _________________
                          </TableCell>
                          <TableCell align="right" colSpan={3} style={{ textAlign: 'right' }}>
                            <br />
                            <br />
                            <b>Teslim Alan İmza</b>
                            <br />
                            <br />
                            <br />
                            _________________
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            </Paper>
          </div>

        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={e => setopenIrsaliye(false)} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

    </Page>
  );
}

export default Scrap;
